import { Cookies } from 'react-cookie'
import {
  AppDashboadService,
  ApproveAttendenceService,
  AttendanceApprovalListService,
  AttendanceDashboardMainService,
  AttendanceDashboardService,
  AttendanceTimeSheetListService,
  DeleteEmployeeFromAttendanceBatchService,
  EditAttendenceService,
  GetAllEmpAttendanceService,
  GetAllTodaysProjectForTimesheetService,
  GetAttendanceFailuresService,
  GetAttendanceFailureByIdService,
  GetDayWiseEmpAttendenceService,
  GetEmpWiseYearlyAttendanceService,
  IgnoreAttendanceFailureService,
  MonthwiseEmpAttendanceDetailsService,
  MyAttendenceService,
  PendingApprovalListService,
  PendingAttendenceListService,
  ResolveAttendanceFailureService,
  SendForApprovalService,
  SubmitTodaysTimesheetService,
  TerminateBatchInitiateService,
  UpdateAttendanceApprovalStatusService,
  UpdateAttendanceService,
  UploadAttendanceTimeSheetService,
  UploadedAttendanceViewService,
  ViewTeamAttendenceService,
  FutureAttendanceApprovalListService,
  FutureAttendanceApprovalUpdateStatusService,
} from '../../services/attendanceService'
import { ApiCallErrorAction, BeginApiCallAction, StopLoadingAction } from './apiStatusActions'
import { LogOutAction } from './userAction'
import {
  AttendanceApprovalDetailsPayload,
  AttendanceApprovalPayload,
  DashboardDetailsResp,
  DaywiseAttendancePayload,
  EditAttendancePayload,
  EditAttendanceResp,
  GetAllEmpAttendenceMonthlyPayload,
  GetAllTodaysProjectForTimesheetResp,
  GetEmpAttendanceYrlySummaryPayload,
  MonthwiseEmpAttendenceDetailsPayload,
  MyAttendancePayload,
  MyAttendanceResp,
  PendingAttendancePayload,
  PendingAttendanceResp,
  SendForApprovalPayload,
  SubmitTodaysTimesheetPayload,
  ViewTeamAttendancePayload,
  ViewTeamAttendanceResp,
  FutureAttendanceApprovalListPayload,
  FutureAttendanceApprovalUpdateStatusPayload,
} from '../../models/attendanceModel'

export enum AttendanceActionTypes {
  Attendance_Dashboard_Success_Action = '[ATTENDANCE] Attendance Dashboard Success Action',
  Pending_Approval_Success_Action = '[ATTENDANCE] Pending Approval Success Action',
  Uploaded_Attendance__View_Success_Action = '[ATTENDANCE] Uploaded Attendance View Success Action',
  Attendance_Detail_Payload_Success_Action = '[ATTENDANCE] Attendance Detail Payload Success Action',
  Update_Attendance_Success_Action = '[ATTENDANCE] Update Attendance Success Action',
  Approve_Attendance_List_Success_Action = '[ATTENDANCE] Approve Attendance List Success Action',
  Attendance_options = '[ATTENDANCE] Attendance option',
  Attendance_Approve_Status_Success_Action = '[ATTENDANCE] Attendance Approve Status Success Action',
  Delete_Employee_Attendance_Batch_Success_Action = '[ATTENDANCE] Delete Employee Attendance Batch Success Action',
  Attendance_Time_Sheet_Success_Action = '[ATTENDANCE] Attendance Time Sheet Success Action',
  Upload_Attendance_Time_Sheet_Success_Action = '[ATTENDANCE] Upload Attendance Time Sheet Success Action',
  Get_All_Emp_Monthly_Attendence_Success_Action = '[ATTENDANCE] Get All Emp Monthly Attendence Success Action',
  Emp_Monthly_Attendence_Details_Success_Action = '[ATTENDANCE] Emp Monthly Attendence Details Success Action',
  Send_For_Approval_Details_Success_Action = '[ATTENDANCE] Send For Approval Details Success Action',
  View_Team_Attendance_Details_Success_Action = '[ATTENDANCE] View Team Attendance Details Success Action',
  Pending_Attendance_List_Success_Action = '[ATTENDANCE] Pending Attendance List Success Action',
  Edit_Attendance_Success_Action = '[ATTENDANCE] Edit Attendance Success Action',
  My_Attendance_Success_Action = '[ATTENDANCE] My Attendance Success Action',
  Get_Emp_Wise_Yearly_Attendance_Success_Action = '[ATTENDANCE] Get Emp Wise Yearly Attendance Success Action',
  Get_DAY_WISE_Attendence_Success_Action = '[ATTENDANCE] GetDay wise Attendence Success Action',
  Dashboard_Details_Success_Action = '[DASHBOARD] Dashboard Success Action',
  Get_Attendance_Dashboard_Master_Success_Action = '[ATTENDANCE] Get Attendance Dashboard Master Success Action',
  Get_Todays_Timesheet_Success_Action = '[ATTENDANCE] Get Todays Timesheet Success Action',
  Attendance_temporal_Set_Action='[ATTENTANCE] Attendance temporal Set Action',
  Get_Attendance_Failure_Logs_Success_Action = '[ATTENDANCE] Get Attendance Failure Logs Success Action',
  Get_Attendance_Failure_Log_Detail_Success_Action = '[ATTENDANCE] Get Attendance Failure Log Detail Success Action',
  Update_Attendance_Failure_Log_Status_Success_Action = '[ATTENDANCE] Update Attendance Failure Log Status Success Action'
}

export const AttendanceDashboardAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Updating Department. Please Wait...',
        type: 2,
      })
    )
    return AttendanceDashboardService(payload.data)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(AttendanceDashboardSuccessAction(response.data))
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const AttendanceDashboardSuccessAction = (data: any) => {
  return {
    type: AttendanceActionTypes.Attendance_Dashboard_Success_Action,
    payload: data,
  }
}

export const GetAllPendingApprovalAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Get All Pending Approval List. Please Wait...',
        type: 2,
      })
    )
    return PendingApprovalListService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(GetAllPendingApprovalSuccessAction(response.data))
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const GetAllPendingApprovalSuccessAction = (data: any) => {
  return {
    type: AttendanceActionTypes.Pending_Approval_Success_Action,
    payload: data,
  }
}

export const UploadeAttendanceViewAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Get Uploaded Attendance View. Please Wait...',
        type: 2,
      })
    )
    return UploadedAttendanceViewService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          // payload.navigateTo(`/attendance/attendance-details`);
          dispatch(
            UploadeAttendanceViewSuccessAction({
              list: response.data.employee_list,
              count: response.data.total_count,
              attendence_fields: response.data.attendence_fields,
            })
          )
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const UploadeAttendanceViewSuccessAction = (data: any) => {
  return {
    type: AttendanceActionTypes.Uploaded_Attendance__View_Success_Action,
    payload: data,
  }
}

export const AttendanceDetailPayloadSuccessAction = (data: any) => {
  return {
    type: AttendanceActionTypes.Attendance_Detail_Payload_Success_Action,
    payload: data,
  }
}

export const UpdateAttendanceAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Creating Department. Please Wait...',
        type: 2,
      })
    )
    return UpdateAttendanceService(payload.update_data)
      .then(async (response) => {
        if (response.status !== 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          // payload.navigateTo(`attendance/attendance-details/`);
          payload.enqueueSnackbar('Successfully Updated', {
            variant: 'success',
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
          })
          dispatch(UploadeAttendanceViewAction(payload.list_data))
          dispatch(UpdateAttendanceSuccessAction())
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const UpdateAttendanceSuccessAction = () => {
  return { type: AttendanceActionTypes.Update_Attendance_Success_Action }
}

export const ApproveAttendanceListAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: ' Attendance List. Please Wait...',
        type: 2,
      })
    )

    return AttendanceApprovalListService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(ApproveAttendanceListSuccessAction(response.data))
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const ApproveAttendanceListSuccessAction = (data: any) => {
  return {
    type: AttendanceActionTypes.Approve_Attendance_List_Success_Action,
    payload: data,
  }
}
export const UpdateApproveAttendanceStatusAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: ' Attendance Update Status. Please Wait...',
        type: 2,
      })
    )
    return UpdateAttendanceApprovalStatusService(payload.data1)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          payload.enqueueSnackbar('Successfully Updated', {
            variant: 'success',
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
          })
          dispatch(GetAllPendingApprovalAction(payload.data2))
          dispatch(UpdateApproveAttendanceStatusSuccessAction())
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const UpdateApproveAttendanceStatusSuccessAction = () => {
  return {
    type: AttendanceActionTypes.Attendance_Approve_Status_Success_Action,
  }
}

export const DeleteEmployeeFromAttendanceBatchAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: ' Attendance Update Status. Please Wait...',
        type: 2,
      })
    )
    return DeleteEmployeeFromAttendanceBatchService(payload.data)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          await payload.enqueueSnackbar('Successfully Deleted', {
            variant: 'success',
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
          })
          dispatch(UploadeAttendanceViewAction(payload.list_data))
          dispatch(DeleteAttendanceFromBatchSuccessAction())
          // dispatch(
          //   UploadeAttendanceViewSuccessAction({
          //     list: response.data.employee_list,
          //     count: response.data.total_count,
          //     // attendence_fields: response.data.attendence_fields,
          //   }))
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const DeleteAttendanceFromBatchSuccessAction = () => {
  return {
    type: AttendanceActionTypes.Delete_Employee_Attendance_Batch_Success_Action,
  }
}

export const AttendanceTimeSheetListAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: ' Attendance From Timesheet. Please Wait...',
        type: 2,
      })
    )
    // console.log(payload)
    return AttendanceTimeSheetListService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(AttendanceTimeSheetListSuccessAction(response.data))
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const AttendanceTimeSheetListSuccessAction = (data: any) => {
  return {
    type: AttendanceActionTypes.Attendance_Time_Sheet_Success_Action,
    payload: data,
  }
}

export const UploadAttendanceTimeSheetAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: ' Upload Attendance From Time Sheet. Please Wait...',
        type: 2,
      })
    )
    // console.log(payload)

    return UploadAttendanceTimeSheetService(payload.data)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          payload.enqueueSnackbar('Successfully Generated', {
            variant: 'success',
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
          })
          dispatch(
            AttendanceDetailPayloadSuccessAction({
              employee_type_id: payload.data[0].employee_type_id,
              organization_id: payload.data[0].organization_id,
              project_id: payload.data[0].project_id,
              attendence_salary_type_id: null,
              project_attendence_id: response.data.project_attendence_id,
              page_index: 0,
              page_size: 2,
              // editable: 0
            })
          )
          payload.navigateTo(`/attendance/attendance-details/1`)
          dispatch(UploadAttendanceTimeSheetSuccessAction())
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const UploadAttendanceTimeSheetSuccessAction = () => {
  return {
    type: AttendanceActionTypes.Upload_Attendance_Time_Sheet_Success_Action,
  }
}

// Attendence New

// Get All Employee Monthly Attendence
export const GetAllEmpAttendanceMonthlyAction = (
  payload: GetAllEmpAttendenceMonthlyPayload
) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: ' Get All Employee Monthly Attendance. Please Wait...',
        type: 2,
      })
    )
    return GetAllEmpAttendanceService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(GetAllEmpAttendanceMonthlySuccessAction(response.data))
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const GetAllEmpAttendanceMonthlySuccessAction = (data: any) => {
  return {
    type: AttendanceActionTypes.Get_All_Emp_Monthly_Attendence_Success_Action,
    payload: data,
  }
}


//Daywise Attendance
export const GetDayWiseEmpAttendenceAction = (
  payload: DaywiseAttendancePayload
) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: ' Get All Employee Day wise Attendance. Please Wait...',
        type: 2,
      })
    )
    return GetDayWiseEmpAttendenceService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(GetDayWiseEmpAttendenceSuccessAction(response.data))
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const GetDayWiseEmpAttendenceSuccessAction = (data: any) => {
  return {
    type: AttendanceActionTypes.Get_DAY_WISE_Attendence_Success_Action,
    payload: data,
  }
}

// Emp Monthly Attendence Details
export const EmpMonthlyAttendanceDetailsAction = ({
  payload,
  successCallback,
}: {
  payload: MonthwiseEmpAttendenceDetailsPayload
  successCallback?: any
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: ' Employee Monthly Attendance Details. Please Wait...',
        type: 2,
      })
    )
    return MonthwiseEmpAttendanceDetailsService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(EmpMonthlyAttendanceDetailsSuccessAction(response.data))
          successCallback?.(response.data)
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const EmpMonthlyAttendanceDetailsSuccessAction = (data: any) => {
  return {
    type: AttendanceActionTypes.Emp_Monthly_Attendence_Details_Success_Action,
    payload: data,
  }
}

// Send For Approval Details
export const SendForApprovalAction = ({
  payload,
  successCallback,
}: {
  payload: SendForApprovalPayload
  successCallback?: any
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: ' Send For Approval Details. Please Wait...',
        type: 2,
      })
    )
    return SendForApprovalService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(SendForApprovalSuccessAction(response.data))
          successCallback?.(response.data)
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const SendForApprovalSuccessAction = (data: any) => {
  return {
    type: AttendanceActionTypes.Send_For_Approval_Details_Success_Action,
    payload: data,
  }
}

// View Team Attendance Details
export const ViewTeamAttendanceDetailsAction = ({
  payload,
  successCallback,
}: {
  payload: ViewTeamAttendancePayload
  successCallback?: any
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: ' View Team Attendance Details. Please Wait...',
        type: 2,
      })
    )
    return ViewTeamAttendenceService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(ViewTeamAttendanceDetailsSuccessAction(response.data))
          successCallback?.(response.data)
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const ViewTeamAttendanceDetailsSuccessAction = (
  data: ViewTeamAttendanceResp
) => {
  return {
    type: AttendanceActionTypes.View_Team_Attendance_Details_Success_Action,
    payload: data,
  }
}

// Pending Attendance Details
export const PendingAttendanceListAction = ({
  payload,
  successCallback,
}: {
  payload: PendingAttendancePayload
  successCallback?: any
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: ' Pending Attendance List. Please Wait...',
        type: 2,
      })
    )
    return PendingAttendenceListService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(PendingAttendanceListSuccessAction(response.data))
          successCallback?.(response.data)
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const PendingAttendanceListSuccessAction = (
  data: PendingAttendanceResp
) => {
  return {
    type: AttendanceActionTypes.Pending_Attendance_List_Success_Action,
    payload: data,
  }
}

// Edit Attendance
export const EditAttendanceAction = ({
  payload,
  successCallback,
}: {
  payload: EditAttendancePayload
  successCallback?: any
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Edit Attendance. Please Wait...',
        type: 2,
      })
    )
    return EditAttendenceService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(PendingAttendanceListSuccessAction(response.data))
          successCallback?.(response.data)
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const EditAttendanceSuccessAction = (data: EditAttendanceResp) => {
  return {
    type: AttendanceActionTypes.Edit_Attendance_Success_Action,
    payload: data,
  }
}

// Approve Attendance
export const ApproveAttendanceAction = ({
  payload,
  successCallback,
}: {
  payload: AttendanceApprovalDetailsPayload
  successCallback?: any
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Approve Attendance. Please Wait...',
        type: 2,
      })
    )
    return ApproveAttendenceService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          successCallback?.(response.data)
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}
// My Attendance
export const MyAttendanceAction = ({
  payload,
  successCallback,
}: {
  payload: MyAttendancePayload
  successCallback?: any
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'My Attendance. Please Wait...',
        type: 2,
      })
    )
    return MyAttendenceService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(PendingAttendanceListSuccessAction(response.data))
          successCallback?.(response.data)
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}

export const MyAttendanceSuccessAction = (data: MyAttendanceResp) => {
  return {
    type: AttendanceActionTypes.My_Attendance_Success_Action,
    payload: data,
  }
}
// Get Employee Wise Yearly Attendance

export const GetEmpWiseYearlyAttendanceSuccessAction = (data: any) => {
  return {
    type: AttendanceActionTypes.Get_Emp_Wise_Yearly_Attendance_Success_Action,
    payload: data,
  }
}

export const GetEmpWiseYearlyAttendanceAction = (
  payload: GetEmpAttendanceYrlySummaryPayload
) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Get Employee Wise Yearly Attendance. Please Wait...',
        type: 2,
      })
    )
    return GetEmpWiseYearlyAttendanceService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(GetEmpWiseYearlyAttendanceSuccessAction(response.data))
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  }
}




export const GetAttendanceDashboardMasterSuccessAction = (data: any) => {
  return {
    type: AttendanceActionTypes.Get_Attendance_Dashboard_Master_Success_Action,
    payload: data,
  }
}

export const GetAttendanceDashboardMasterAction = (
  payload: any
) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Fatching Dashboard Data... Please Wait...',
        type: 2,
      })
    )
    return AttendanceDashboardMainService(payload)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(GetAttendanceDashboardMasterSuccessAction(response.data))
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      }).finally(() => {
        dispatch(StopLoadingAction());  
      })
  }
}



export const DashboardDetailsAction = () => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Fatching Dashboard Data... Please Wait...',
        type: 2,
      })
    )
    return AppDashboadService()
      .then(async response => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
        } else {
          dispatch(DashboardDetailsSuccessAction(response.data));
        }
      })
       .catch((error) => {
        if (error?.response?.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      }).finally(() => {
        dispatch(StopLoadingAction());  
      })
  };
};


export const DashboardDetailsSuccessAction = (
  payload: DashboardDetailsResp,
) => {
  return {
    type: AttendanceActionTypes.Dashboard_Details_Success_Action,
    payload: payload,
  };
};





export const GetAllTodaysProjectForTimesheetAction = (payload: any) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Fatching Dashboard Data... Please Wait...',
        type: 2,
      })
    )
    return GetAllTodaysProjectForTimesheetService(payload)
      .then(async response => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
          
        } else {
          dispatch(GetAllTodaysProjectForTimesheetSuccessAction(response.data));
        }
      })
        .catch((error) => {
        if (error?.response?.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      })
  };
};

export const GetAllTodaysProjectForTimesheetSuccessAction = (
  payload: GetAllTodaysProjectForTimesheetResp,
) => {
  return {
    type: AttendanceActionTypes.Get_Todays_Timesheet_Success_Action,
    payload: payload,
  };
};






export const SubmitTodaysTimesheetAction = ({
  payload,
  successcallBack,
}: {
  payload: SubmitTodaysTimesheetPayload;
  successcallBack?: any;
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Fatching Dashboard Data... Please Wait...',
        type: 2,
      })
    )
    return SubmitTodaysTimesheetService(payload)
      .then(async response => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
          
        } else {
          successcallBack?.();
        }
      })
       .catch((error) => {
        if (error?.response?.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      }).finally(() => {
        dispatch(StopLoadingAction());  
      })
  
  };
};



export const AttendanceTemporalSuccessAction = (
  payload: any,
) => {
  return {
    type: AttendanceActionTypes.Attendance_temporal_Set_Action,
    payload: payload,
  };
};


export const TerminateBatchInitiateAction = ({ enqueueSnackbar, successCallback }: {enqueueSnackbar?: any, successCallback?: any}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Terminating Batch. Please Wait...',
        type: 2,
      })
    )
    return TerminateBatchInitiateService()
      .then(async response => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data));
          
        } else {
          successCallback?.();

          enqueueSnackbar(response?.data?.message ?? `Successfully Generated`, {
            variant: 'success',
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
          })
        }
      })
       .catch((error) => {
        if (error?.response?.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      }).finally(() => {
        dispatch(StopLoadingAction());  
      })
  
  };
};

// Attendance Failure Logs
export const GetAttendanceFailureLogsSuccessAction = (data: any) => {
  return {
    type: AttendanceActionTypes.Get_Attendance_Failure_Logs_Success_Action,
    payload: data,
  }
}

export const GetAttendanceFailureLogsAction = ({
  params,
  successCallback,
}: {
  params?: {
    employee_id?: string;
    organization_id?: number;
    attendance_date_from?: string;
    attendance_date_to?: string;
    source?: string;
    operation?: string;
    status?: string;
    search?: string;
    page?: number;
    limit?: number;
    sort_by?: string;
    sort_order?: "asc" | "desc";
  };
  successCallback?: any;
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Fetching attendance failure logs. Please Wait...',
        type: 2,
      })
    )
    return GetAttendanceFailuresService(params)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(GetAttendanceFailureLogsSuccessAction(response.data))
          successCallback?.(response.data)
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      }).finally(() => {
        dispatch(StopLoadingAction())
      })
  }
}

export const GetAttendanceFailureLogDetailSuccessAction = (data: any) => {
  return {
    type: AttendanceActionTypes.Get_Attendance_Failure_Log_Detail_Success_Action,
    payload: data,
  }
}

export const GetAttendanceFailureLogDetailAction = ({
  id,
  successCallback,
}: {
  id: number;
  successCallback?: any;
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Fetching attendance failure log details. Please Wait...',
        type: 2,
      })
    )
    return GetAttendanceFailureByIdService(id)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(GetAttendanceFailureLogDetailSuccessAction(response.data))
          successCallback?.(response.data)
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      }).finally(() => {
        dispatch(StopLoadingAction())
      })
  }
}

export const UpdateAttendanceFailureLogStatusSuccessAction = () => {
  return {
    type: AttendanceActionTypes.Update_Attendance_Failure_Log_Status_Success_Action,
  }
}

export const ResolveAttendanceFailureAction = ({
  id,
  successCallback,
}: {
  id: number;
  successCallback?: any;
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Resolving attendance failure log. Please Wait...',
        type: 2,
      })
    )
    return ResolveAttendanceFailureService(id)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(UpdateAttendanceFailureLogStatusSuccessAction())
          successCallback?.(response.data)
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      }).finally(() => {
        dispatch(StopLoadingAction())
      })
  }
}

export const IgnoreAttendanceFailureAction = ({
  id,
  successCallback,
}: {
  id: number;
  successCallback?: any;
}) => {
  return (dispatch: any, getState: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Ignoring attendance failure log. Please Wait...',
        type: 2,
      })
    )
    return IgnoreAttendanceFailureService(id)
      .then(async (response) => {
        if (response.status != 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          dispatch(UpdateAttendanceFailureLogStatusSuccessAction())
          successCallback?.(response.data)
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error.response.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message,
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Error encountered please try again later',
            })
          )
        }
      }).finally(() => {
        dispatch(StopLoadingAction())
      })
  }
}

// Future Attendance Approval List
export const FutureAttendanceApprovalListAction = ({
  payload,
  successCallback,
}: {
  payload: FutureAttendanceApprovalListPayload
  successCallback?: any
}) => {
  return (dispatch: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Loading Future Attendance Approvals. Please Wait...',
        type: 2,
      })
    )
    return FutureAttendanceApprovalListService(payload)
      .then(async (response) => {
        if (response.status !== 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          successCallback?.(response.data)
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error?.response?.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message || 'Internal server error',
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message || 'Error encountered please try again later',
            })
          )
        }
      })
      .finally(() => {
        dispatch(StopLoadingAction())
      })
  }
}

// Future Attendance Approval Update Status
export const FutureAttendanceApprovalUpdateStatusAction = ({
  payload,
  successCallback,
}: {
  payload: FutureAttendanceApprovalUpdateStatusPayload
  successCallback?: any
}) => {
  return (dispatch: any) => {
    dispatch(
      BeginApiCallAction({
        count: 1,
        message: 'Updating status. Please Wait...',
        type: 2,
      })
    )
    return FutureAttendanceApprovalUpdateStatusService(payload)
      .then(async (response) => {
        if (response.status !== 200) {
          dispatch(ApiCallErrorAction(response.data))
        } else {
          successCallback?.(response.data)
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          let cook = new Cookies()
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: 'Please Login again to continue.',
            })
          )
          cook.remove('user', { path: '/' })
          dispatch(LogOutAction())
        } else if (error?.response?.status === 500) {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message || 'Internal server error',
            })
          )
        } else {
          dispatch(
            ApiCallErrorAction({
              errorCode: '',
              message: error?.response?.data?.message || 'Error encountered please try again later',
            })
          )
        }
      })
      .finally(() => {
        dispatch(StopLoadingAction())
      })
  }
}

